import {createStructuredSelector} from "reselect";

export const currentUserSelector = createStructuredSelector({
    isLogged: state => state.currentUser.isLogged,
});
